import { createExperiments } from '@cbhq/experiments';

export const workspaceExperimentConfig = {
  // workspace_audit_log
  t0018_aac156e2: ['control', 'treatment'] as const,
  // workspace_consensus
  t0018_7b870e9f: ['control', 'treatment'] as const,
  // workspace_settings
  t0018_3ab23203: ['control', 'treatment'] as const,
  // workspace_member_management_step_up
  t0018_c2608c57: ['control', 'treatment'] as const,
  // workspace_domain_claims
  t0018_1a1ab525: ['control', 'treatment'] as const,
  // workspace_navigation_revamp (IDFE-3660): treatment renders the shared
  // profile-menu-driven entity switcher instead of the bespoke org picker.
  // NOTE: #7241 also registered this id for workspace_team_remove_product_tabs
  // (see Members.tsx) by mistake — that experiment needs its own id.
  // Also gates the IDFE-3663 workspace-role tray rename + divider (see
  // SingleLEEditTray.tsx, SingleLEInviteTray.tsx, MultiLEEditTray.tsx,
  // MultiLEInviteTray.tsx), reusing this id deliberately since it is part of
  // the same Workspace Nav Surge rollout.
  t0018_74bfb564: ['control', 'treatment'] as const,
} as const;

const AppExperiments = createExperiments(workspaceExperimentConfig);

export default AppExperiments;
